export function Course__Price(course: any) {
  return course.price !== undefined ? course.price : course.summary?.price;
}
